// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"256":"npm.chart.js-bf2cd571","416":"npm.chart.js-373d114a","825":"npm.xlsx"}[chunkId] || chunkId) + "-legacy." + {"223":"107adecf","241":"5af302af","256":"7dd949b7","260":"78469ea7","287":"2c9647fa","416":"df776731","672":"8dc7f7c4","825":"85a51195","875":"b9cf9438"}[chunkId] + ".js";
};